module.exports = __webpack_public_path__ + "static/media/ObservationCommunication.6c9da71b.jpg";